export const
    SetTrial: ITrialSettingsPageSetTrialActionCreator = (trialId) => {
        return {
            type: TRIAL_SETTINGS_PAGE_SET_TRIAL,
            trialId
        }
    };

export const
    TRIAL_SETTINGS_PAGE_SET_TRIAL = "TRIAL_SETTINGS_PAGE_SET_TRIAL"

/* Actions */

export interface ITrialSettingsPageSetTrialAction {
    type: "TRIAL_SETTINGS_PAGE_SET_TRIAL",
    trialId: number;
}

/* Action Creators */

export interface ITrialSettingsPageSetTrialActionCreator {
    (
        trialId: number
    ): ITrialSettingsPageSetTrialAction;
}


/* Final Export of actions */
export type TrialSettingsPageAction =
    ITrialSettingsPageSetTrialAction;
